/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponse,
  GetPlayslipMessageCatalogResponse,
  GetPlayslipThemesResponse,
  PlayslipTheme,
  PlayslipThemeCreateRequest,
  PlayslipThemeUpdateRequest,
} from '../models/index';
import {
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    GetPlayslipMessageCatalogResponseFromJSON,
    GetPlayslipMessageCatalogResponseToJSON,
    GetPlayslipThemesResponseFromJSON,
    GetPlayslipThemesResponseToJSON,
    PlayslipThemeFromJSON,
    PlayslipThemeToJSON,
    PlayslipThemeCreateRequestFromJSON,
    PlayslipThemeCreateRequestToJSON,
    PlayslipThemeUpdateRequestFromJSON,
    PlayslipThemeUpdateRequestToJSON,
} from '../models/index';

export interface CreatePlayslipThemeRequest {
    customerId: string;
    playslipThemeCreateRequest: PlayslipThemeCreateRequest;
    xClientID?: string;
    xRequestID?: string;
}

export interface DeletePlayslipThemeRequest {
    customerId: string;
    themeId: string;
    xClientID?: string;
    xRequestID?: string;
}

export interface GetPlayslipMessageCatalogRequest {
    customerId: string;
    xClientID?: string;
    xRequestID?: string;
}

export interface GetPlayslipThemeRequest {
    customerId: string;
    themeId: string;
    xClientID?: string;
    xRequestID?: string;
}

export interface GetPlayslipThemesRequest {
    customerId: string;
    xClientID?: string;
    xRequestID?: string;
}

export interface UpdatePlayslipThemeRequest {
    customerId: string;
    themeId: string;
    playslipThemeUpdateRequest: PlayslipThemeUpdateRequest;
    xClientID?: string;
    xRequestID?: string;
}

/**
 * 
 */
export class PlayslipsAdminApi extends runtime.BaseAPI {

    /**
     * Create a playslip theme. Its identifier is fixed at creation, so a second theme under a name the customer already uses is a conflict.
     */
    async createPlayslipThemeRaw(requestParameters: CreatePlayslipThemeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PlayslipTheme>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling createPlayslipTheme().'
            );
        }

        if (requestParameters['playslipThemeCreateRequest'] == null) {
            throw new runtime.RequiredError(
                'playslipThemeCreateRequest',
                'Required parameter "playslipThemeCreateRequest" was null or undefined when calling createPlayslipTheme().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["write:games"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/playslips/themes`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PlayslipThemeCreateRequestToJSON(requestParameters['playslipThemeCreateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PlayslipThemeFromJSON(jsonValue));
    }

    /**
     * Create a playslip theme. Its identifier is fixed at creation, so a second theme under a name the customer already uses is a conflict.
     */
    async createPlayslipTheme(requestParameters: CreatePlayslipThemeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PlayslipTheme> {
        const response = await this.createPlayslipThemeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a playslip theme. A host app asking for it afterwards falls back to its built-in colours.
     */
    async deletePlayslipThemeRaw(requestParameters: DeletePlayslipThemeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling deletePlayslipTheme().'
            );
        }

        if (requestParameters['themeId'] == null) {
            throw new runtime.RequiredError(
                'themeId',
                'Required parameter "themeId" was null or undefined when calling deletePlayslipTheme().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["write:games"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/playslips/themes/{themeId}`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));
        urlPath = urlPath.replace(`{${"themeId"}}`, encodeURIComponent(String(requestParameters['themeId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a playslip theme. A host app asking for it afterwards falls back to its built-in colours.
     */
    async deletePlayslipTheme(requestParameters: DeletePlayslipThemeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deletePlayslipThemeRaw(requestParameters, initOverrides);
    }

    /**
     * Get every piece of playslip copy a customer may reword, with the text players see when a theme leaves it out.
     */
    async getPlayslipMessageCatalogRaw(requestParameters: GetPlayslipMessageCatalogRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPlayslipMessageCatalogResponse>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling getPlayslipMessageCatalog().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["read:games"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/playslips/messages-catalog`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPlayslipMessageCatalogResponseFromJSON(jsonValue));
    }

    /**
     * Get every piece of playslip copy a customer may reword, with the text players see when a theme leaves it out.
     */
    async getPlayslipMessageCatalog(requestParameters: GetPlayslipMessageCatalogRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPlayslipMessageCatalogResponse> {
        const response = await this.getPlayslipMessageCatalogRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get one playslip theme by its identifier.
     */
    async getPlayslipThemeRaw(requestParameters: GetPlayslipThemeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PlayslipTheme>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling getPlayslipTheme().'
            );
        }

        if (requestParameters['themeId'] == null) {
            throw new runtime.RequiredError(
                'themeId',
                'Required parameter "themeId" was null or undefined when calling getPlayslipTheme().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["read:games"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/playslips/themes/{themeId}`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));
        urlPath = urlPath.replace(`{${"themeId"}}`, encodeURIComponent(String(requestParameters['themeId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PlayslipThemeFromJSON(jsonValue));
    }

    /**
     * Get one playslip theme by its identifier.
     */
    async getPlayslipTheme(requestParameters: GetPlayslipThemeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PlayslipTheme> {
        const response = await this.getPlayslipThemeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get every playslip theme the customer has defined, ordered by identifier.
     */
    async getPlayslipThemesRaw(requestParameters: GetPlayslipThemesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPlayslipThemesResponse>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling getPlayslipThemes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["read:games"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/playslips/themes`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPlayslipThemesResponseFromJSON(jsonValue));
    }

    /**
     * Get every playslip theme the customer has defined, ordered by identifier.
     */
    async getPlayslipThemes(requestParameters: GetPlayslipThemesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPlayslipThemesResponse> {
        const response = await this.getPlayslipThemesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Replace a theme\'s colours. A role left out of the request is cleared, not kept, and the theme\'s identifier cannot be changed.
     */
    async updatePlayslipThemeRaw(requestParameters: UpdatePlayslipThemeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PlayslipTheme>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling updatePlayslipTheme().'
            );
        }

        if (requestParameters['themeId'] == null) {
            throw new runtime.RequiredError(
                'themeId',
                'Required parameter "themeId" was null or undefined when calling updatePlayslipTheme().'
            );
        }

        if (requestParameters['playslipThemeUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'playslipThemeUpdateRequest',
                'Required parameter "playslipThemeUpdateRequest" was null or undefined when calling updatePlayslipTheme().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["write:games"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/playslips/themes/{themeId}`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));
        urlPath = urlPath.replace(`{${"themeId"}}`, encodeURIComponent(String(requestParameters['themeId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: PlayslipThemeUpdateRequestToJSON(requestParameters['playslipThemeUpdateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PlayslipThemeFromJSON(jsonValue));
    }

    /**
     * Replace a theme\'s colours. A role left out of the request is cleared, not kept, and the theme\'s identifier cannot be changed.
     */
    async updatePlayslipTheme(requestParameters: UpdatePlayslipThemeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PlayslipTheme> {
        const response = await this.updatePlayslipThemeRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
